"use client";
import { useEffect, useRef } from "react";
import Squircle from "./Squircle";

export default function ParallaxImage({ children, speed = 0.3, start = 0, end = 1, className = "", showSquircle = false }) {
	const ref = useRef();

	useEffect(() => {
		const el = ref.current;
		if (!el) return;

		// Ensure the image always visually fills the container during movement
		const extra = Math.abs(speed * 100); // max vertical shift

		const update = () => {
			const rect = el.getBoundingClientRect();
			const windowHeight = window.innerHeight;
			const isTopScroll = el.classList.contains("top-scroll");

			if (rect.top < windowHeight && rect.bottom > 0) {
				let progress;
				if (isTopScroll) {
					const scrollY = window.scrollY || window.pageYOffset;
					const startScroll = 0;
					const endScroll = rect.top + scrollY;
					progress = Math.min(Math.max((scrollY - startScroll) / (endScroll - startScroll + windowHeight), 0), 1);
				} else {
					progress = Math.min(Math.max((windowHeight - rect.top) / (windowHeight + rect.height), 0), 1);
				}
				const eased = start + (end - start) * progress;
				el.style.transform = `translateY(${eased * speed * 100}px)`;
			}

			requestAnimationFrame(update);
		};

		update();
		return () => cancelAnimationFrame(update);
	}, [speed, start, end]);

	return (
		<div className="parallax-container">
			{showSquircle && <Squircle size="bg" />}
			<div className="parallax-content">
				<div
					ref={ref}
					className={`parallax-inner ${className || ""}`}
					style={{
						willChange: "transform",
						width: "100%",
					}}
				>
					{children}
				</div>
			</div>
		</div>
	);
}
